// extracted by mini-css-extract-plugin
module.exports = {"exchange-code-input":"style_exchange-code-input__dg1zN"};